import { useContext } from "react";
import { AR, FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { RefetchScope, RetailOrderContext } from "../context/RetailOrderContext";

export default function RetailOrderFilesButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const defaultFileType =
		order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign) ? FileTypes.CabinetDesignPacket :
			order.details.activeARs.includes(AR.UploadLaminateOrderForm) ? FileTypes.LaminateOrderForm :
				order.details.activeARs.includes(AR.UploadVanityOrderForm) ? FileTypes.VanityOrderForm : undefined;

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.retailOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.RetailOrder}
			orderTypeID={order.details.roTypeID}
			defaultFileType={defaultFileType}
			useFileTypes={true}
			hideDeleteButton={false}
			replaceFile={!!defaultFileType}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
		/>
	)
}
